import theme from 'theme';

const styles = {
  textField: {
    color: theme.palette.primary[700],
    fontWeight: 400,
    fontSize: '1rem',
    borderRadius: '8px',
    border: `1px solid ${theme.palette.primary[700]}`,
  },
  saveButton: {
    color: '#65C687',
    borderColor: '#65C687',
    maxWidth: '10rem',
  },
  charCount: {
    fontSize: '0.8rem',
    fontWeight: 500,
  },
};

export default styles;
